/* Internal Vars */

// import SearchJar from "./jar";

/* Services */
import SearchService from "./service";

/* Storage */
// import SearchStorage from "./storage";

/* Factories */
import SearchFactory from "./factory";

// /* Facades */
import Search from "./facade";

const modul = angular
    .module("SearchModule", [])

    /**
     * BookingJar - Holds variables internally
     */
    // .service("SearchJar", BookingJar)

    /**
     * Services
     * * can only have utility dependencies
     */
    .factory("SearchService", SearchService)

    /**
     * Storage
     * can only have utility and services as dependencies
     */
    // .factory("BasketStorage", BasketStorage)

    /**
     * Factories
     */
    .factory("SearchFactory", SearchFactory)

    /**
     * Facades
     */
    .factory("Search", Search);

export default modul.name;
